export default __webpack_public_path__ + "static/PC_4_5-b7224e53a5325f1d357d90a5c32b5869.png";